var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C15.45 32 14.975 31.8083 14.575 31.425C14.1917 31.025 14 30.55 14 30V18C14 17.45 14.1917 16.9833 14.575 16.6C14.975 16.2 15.45 16 16 16H32C32.55 16 33.0167 16.2 33.4 16.6C33.8 16.9833 34 17.45 34 18V30C34 30.55 33.8 31.025 33.4 31.425C33.0167 31.8083 32.55 32 32 32H16ZM24 25L32 20V18L24 23L16 18V20L24 25Z",
    fill: "#B73030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBell);
export default __webpack_public_path__ + "static/media/link-bell.d06f2246ed2b91e530f6a3b606b3cf93.svg";
export { ForwardRef as ReactComponent };